import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Wow",
  "description": "",
  "published": "2006-11-05T00:00:00.000Z",
  "redirect_from": ["/blog/wow/swizec/370"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Two days ago, in the early morning of Friday, when I awoke and wanted to begin writing for the day, for there was naught else to be done, the computer refused to boot it. It came up to the point of laoding up 3d acceleration and properly utilise the graphics card and simply froze and would not budge. After trying this a few times a decision was made that a new graphics card is in order.`}</p>
    <p>{`A quick dash to the tech store where apparently getting a new card that works with the AGP port is a difficult task but in the end I managed to get a quite cheap Radeon x1600 that is a LOT better than my old GeForce 2 MX 400.`}</p>
    <p>{`So I come home with a lovely looking black box and put the new card in the computer, all fine and dandy, but it still doesn't boot up properly. A kernel update is needed. After some time fiddling with getting that to work properly and support everything that's needed (I always forget a bunch of stuff) there come Xorg problems.`}</p>
    <p>{`And it came to the point that apparently I had to rebuild the whole Xorg and at the same time migrate to the new modular version of the thing. After long hours of getting that to work well enough to be usable came the idea of having dual screen. Now sure, it works perfectly fine at first glance, but you soon notice that rebuilding the entire KDE has to be done in order for it to work properly.`}</p>
    <p>{`Now I am 6000 words behind schedule and still waiting for things to compile and install. It is times like these that make me ponder why exactly I'm using Gentoo and not some binary driven thing like Debian or Ubuntu. Oh well, I have 9000 words to write today if I desire to catch up and it makes me want to weep like a little baby.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      